import React from 'react';

// Material
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { utils } from '../../../../utils/utils';

const ProductsTable = ({ items = [], currency = 'ARS' }) =>
    <Grid container spacing={1}>
        <Grid size={4}>
            <Typography variant='subtitle2'>
                Sku
            </Typography>
        </Grid>
        <Grid size={4}>
            <Typography align='right' variant='subtitle2'>
                Cantidad
            </Typography>
        </Grid>
        <Grid size={4}>
            <Typography align='right' variant='subtitle2'>
                Descuento
            </Typography>
        </Grid>
        {   items
                .map((item, index) => {
                    return (
                        <Grid key={index} size={12}>
                            <Grid container>
                                <Grid size={4}>
                                    <Typography component='span' variant='body2' display='block'>
                                        <strong>{item?.refId}</strong>
                                    </Typography>
                                </Grid>
                                <Grid size={4}>
                                    <Typography component='span' variant='body2' align='right' display='block'>
                                        <strong>{item?.quantity}</strong>
                                    </Typography>
                                </Grid>
                                <Grid size={4}>
                                    <Typography component='span' variant='body2' align='right' display='block'>
                                        {currency} <strong>{utils.formatMoney(item?.discount)}</strong>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })
        }
    </Grid>

export default ProductsTable;